module.exports = __webpack_public_path__ + "img/2_1-commerciale-mercato-0.a4ad8c20.png";